import { useDropzone } from "react-dropzone";
import Icon from "../Icon";
import { useState, useEffect } from "react";
import { FaLock } from "react-icons/fa";
// import Box from "../Box";

function nameValidator(file:any) {
  var english = /^[a-zA-Z0-9._ -]+$/;
  if (!english.test(file.name)) {
    return {
      code: "name-not-in-english",
      message: `Name is not in english characters`
    };
  }

  return null
}

function DropZone({
  multiple,
  onDrop,
  onChange,
  progress,
  isUploadDone,
  isReset,
  accept

}: {
  multiple: any;
  onDrop: any;
  onChange: any;
  progress?: any;
  isUploadDone?: boolean;
  isReset?: boolean;
  accept?: any;
  
}) {
  // Declaration ----------------------------
  const { acceptedFiles, fileRejections, getRootProps, getInputProps } =
    useDropzone({
      multiple,
      onDrop,
      maxSize: 20000000, //max size 20MB
      disabled: isUploadDone,
      validator: nameValidator,
      accept: accept
    });
  const [uploadFiles, setUploadFiles] = useState<File[]>([]);
  const [rejectedFiles, setRejectedFiles] = useState<any>([]);

  const [renderFiles, setRenderFiles] = useState<any[]>([]);
  const [renderRejectionFiles, setRenderRejectionFiles] = useState<any[]>([]);

  const [updateProgress, setUpdateProgress] = useState<any>();

  // const [showAnimation, setShowAnimation] = useState<boolean>(false);

  //Action ----------------------------------
  const removeFile = (file: any, progressFile: any) => {
    console.log(file, progressFile);

    if (uploadFiles) {
      const index = uploadFiles.indexOf(file, 0);

      if (index > -1) {
        const newFiles = [...uploadFiles];
        newFiles.splice(index, 1);
        setUploadFiles(newFiles);
      }
    }

    if (updateProgress) {
      const progressIndex = updateProgress.indexOf(progressFile, 0);
      if (progressIndex > -1) {
        const newProgressFiles = [...updateProgress];
        newProgressFiles.splice(progressIndex, 1);
        setUpdateProgress(newProgressFiles);
      }
    }
  };

  const removeRejectionFile = (file: any) => {
    if (rejectedFiles) {
      const index = rejectedFiles.indexOf(file, 0);
      if (index > -1) {
        const newFiles = [...rejectedFiles];
        newFiles.splice(index, 1);
        setRejectedFiles(newFiles);
      }
    }
  };

  //Hook ----------------------------------
  useEffect(() => {
    setUpdateProgress(progress);
  }, [progress]);

  // useEffect(()=>{
  //   console.log('updateProgress',updateProgress);

  // },[updateProgress]);

  useEffect(() => {
    const currentFiles = uploadFiles.concat(acceptedFiles);
    setUploadFiles(currentFiles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [acceptedFiles]);

  useEffect(() => {
    setRejectedFiles(fileRejections);
    // onChange(uploadFiles, rejectedFiles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileRejections]);

  useEffect(() => {
    const files = uploadFiles.map((file: any, index: number) => {
      return (
        <li
          key={"pass_" + file.path + index}
          className="mb-1 rounded-sm hover:bg-gray-200"
        >
          <div className="flex flex-row justify-between">
            <span
              className={`mx-2 my-2 text-xs font-bold ${
                isUploadDone ? "text-green-600" : "text-blue-600"
              }`}
            >
              {file.path} -{" "}
              <span className="italic font-normal text-black">
                {humanFileSize(file.size,true)}
              </span>
            </span>
            {!isUploadDone && !updateProgress && (
              <button
                onClick={(event) => {
                  event.preventDefault();
                  removeFile(
                    file,
                    updateProgress ? updateProgress[index] : undefined
                  );
                  
                }}
                className="mx-2 my-2"
              >
                <Icon name="trash-alt" />
              </button>
            )}
          </div>
          {updateProgress && (
            <div className="w-full h-1 bg-gray-200">
              <div
                className="h-1 bg-blue-600"
                style={{
                  width: `${updateProgress[index].progress}`,
                }}
              ></div>
            </div>
          )}
        </li>
      );
    });
    setRenderFiles(files);
    onChange(uploadFiles, rejectedFiles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadFiles, updateProgress]);

  useEffect(() => {

    // rejectedFiles.length > 0 ? setShowAnimation(true) : setShowAnimation(false);

    // console.log('rejectedFiles.length',rejectedFiles.length,showAnimation);
    

    const files = rejectedFiles.map((r_file: any, index: number) => (
      <li
        key={"fail_" + r_file.file.path + index}
        className="pb-2 mb-1 rounded-sm hover:bg-gray-200"
      >
        <div className="flex flex-row justify-between">
          <span className="mx-2 mt-2 text-xs font-bold text-red-600">
            {r_file.file.path} -{" "}
            <span className="italic font-normal text-black underline decoration-red-500 decoration-dashed decoration-2">
              {humanFileSize(r_file.file.size,true)}
            </span>
          </span>
          <button
            onClick={(event) => {
              event.preventDefault();
              removeRejectionFile(r_file);
              onChange(uploadFiles, rejectedFiles);
            }}
            className="mx-2 my-2"
          >
            <Icon name="trash-alt" />
          </button>
        </div>
        {r_file.errors.map((err: any, index: number) => {
          return (
            <div key={`err_${index}`} className="mx-2 text-xs">
              {err.code} : {err.message}
            </div>
          );
        })}
      </li>
    ));
    setRenderRejectionFiles(files);
    onChange(uploadFiles, rejectedFiles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rejectedFiles]);

  useEffect(() => {
    if (isReset) {
      setUploadFiles([]);
      setRejectedFiles([]);
    }
  }, [isReset]);

  // Return --------------------------------------
  return (
    <section className="mx-12 sm:mx-24 md:mx-36 lg:mx-60 xl:mx-72">
      <div
        {...getRootProps({
          className:
            "dropzone bg-gray-200 h-32 rounded-md grid content-center justify-center",
        })}
      >
        <input {...getInputProps()} />
        {isUploadDone ? (
          <div>
            <div className="flex justify-center">
              <FaLock size={30} className="fill-gray-500" />
            </div>

            <div className="flex justify-center">
              <span className="mt-2 text-gray-600">"Locked!"</span>
            </div>
            <div className="flex justify-center">
              <span className="mt-2 text-xs text-yellow-500">
                Dropzon has been locked.
              </span>
            </div>
          </div>
        ) : (
          <div>
            <div className="flex justify-center">
              <Icon name="hdd" />
            </div>

            <div className="flex justify-center">
              <span className="mt-2 text-gray-600">
                Click or drag file to this area to upload
              </span>
            </div>
            <div className="flex justify-center">
              <span className="mt-2 text-xs text-gray-500">
                Support for a single or bulk upload. Maximum file size{" "}
                {/* <Box isShow={ showAnimation }><span className="font-bold">20MB</span></Box>{" "}
                , filename in <Box isShow={ showAnimation }><span  className="font-bold"> English</span></Box> */}
              </span>
            </div>
          </div>
        )}
      </div>
      <aside className="mt-2">
        <div className="overflow-y-auto max-h-40">
          <ul>{renderFiles}</ul>
          <ul>{renderRejectionFiles}</ul>
        </div>
      </aside>
    </section>
  );
}
// Functions ----------------------------------

function humanFileSize(bytes: number, si = false, dp = 1) {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  const units = si
    ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  );

  return bytes.toFixed(dp) + " " + units[u];
}
export default DropZone;
